<template>
  <div class="col backgroundForm">
    <div class="col col-md-10 offset-md-1">
            <div class="col col-md-6 offset-md-3">
                <div class="alert alert-danger" role="alert">
                    <h4 class="alert-heading">Denominativos y Registro de Unidades</h4>        
                    <hr>
                    <p>Asignacion de Denominativos y Unidades </p>
                </div>
            </div>
        </div>
    <nav>
        <div class="nav nav-pills" id="nav-tab" role="tablist">
            
            <a class="nav-item nav-link active" id="nav-second-traffic" data-toggle="tab" href="#nav-denominativo" role="tab" aria-controls="nav-profile" aria-selected="false">Listado GG.UU. o CC.PP.</a>
            <a class="nav-item nav-link" id="nav-init-traffic" data-toggle="tab" href="#nav-reg-uu" role="tab" aria-controls="nav-home" aria-selected="true">Registro de GG.UU. o CC.PP.</a>
            
            <a class="nav-item nav-link" id="nav-init-traffic" data-toggle="tab" href="#nav-uu-list" role="tab" aria-controls="nav-home" aria-selected="true">Listado de UU/CC.PP.</a>
            <a class="nav-item nav-link" id="nav-init-traffic" data-toggle="tab" href="#nav-reg-uuccpp" role="tab" aria-controls="nav-home" aria-selected="true">Registro de UU/CC.PP.</a>

        </div>
    </nav>

    <div class="tab-content" id="nav-tabContent">
        <br>            
    
        <div class="tab-pane fade show active"  id="nav-denominativo" role="tabpanel" aria-labelledby="nav-home-tab" >
            <!-- tab 1 -->
            <button class="btn btn-outline-primary col-md-4 offset-md-4" @click="mListDenominativos">
                <font-awesome-icon icon="list" /> Listar 
            </button>
            
            <br>
            
            <div class="table table-responsive" v-if="list_categoria_unidad.length > 0">
                <table class="table table-sm">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Descripcion</th>
                            <th>Abreviatura</th>
                            <th>Estado</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(lcr, key) in list_categoria_unidad" :key="lcr.id">
                            <td>{{ key+1 }}</td>
                            <td>{{  lcr.detail  }}</td>
                            <td>{{ lcr.short_detail }}</td>
                            <td>
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" :id="lcr.id" v-model="lcr.state" @click="mChangeStateDenominativo(lcr.id)" >
                                    <label class="custom-control-label" :for="lcr.id"><span :class="lcr.state ? 'alert-success':'alert-danger'">{{ lcr.state_parameter==='A' ? 'ACTIVO':'INACTIVO'  }} </span></label>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="tab-pane fade" id="nav-reg-uu" role="tabpanel" aria-labelledby="nav-home-tab">
            <h6>Registro de Grandes Unidades, Unidades o Capitanias de Puerto</h6>
            <hr>
            <div class="form-row">
                <div class="form-group col-12 col-md-6">
                    <label for="ordop_title">Nombre Gran Unidad, Unidad, CC.PP. <span class="required-text">*</span></label>
                    <input type="text" class="form-control" id="ordop_title" placeholder="CAPITANIA DE PUERTO MAYOR" v-model="dts_reg_gg_uu.descripcion"  autocomplete="off">
                </div>
                <div class="form-group col-12 col-md-6">
                    <label for="type_ordop">Abreviatura <span class="required-text">*</span></label>
                    <input type="text" minlength="1" maxlength="10" class="form-control" id="ordop_title" placeholder="CP. MY."  autocomplete="off" v-model="dts_reg_gg_uu.corto">
                </div>
            </div>
            <button class="btn btn-success col-12 col-md-4 offset-md-4" :disabled="animate" @click="mSaveNewUU">
                <font-awesome-icon icon="save" :spin="animate" size="2x" /> Registrar
            </button>
        </div>

        <!-- aqui va de las uu o capitanias de puerto -->
        <div class="tab-pane fade"  id="nav-uu-list" role="tabpanel" aria-labelledby="nav-home-tab" >
            <!-- tab 1 -->
            <button class="btn btn-outline-primary col-md-4 offset-md-4" @click="mListUUCCPP">
                <font-awesome-icon icon="list" /> Listar UU./CC.PP. 
            </button>
            
            <br>
            
            <div class="table table-responsive" v-if="list_uu_ccpp.length > 0">
                <table class="table table-sm">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Denominativo</th>
                            <th>Nombre Unidad</th>
                            <th>Estado</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(ruc, key) in list_uu_ccpp" :key="ruc.id">
                            <td>{{ key+1 }}</td>
                            <td>{{ ruc.short_category }}</td>
                            <td>{{  ruc.name_port  }}</td>
                            <td>
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" :id="ruc.id" v-model="ruc.status" @click="mChangeStateUUCCPP(ruc.id)" >
                                    <label class="custom-control-label" :for="ruc.id"><span :class="ruc.status ? 'alert-success':'alert-danger'">{{ ruc.state_parameter==='A' ? 'ACTIVO':'INACTIVO'  }} </span></label>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- aqui va el registro de unidades de las capitanias de puerto -->
        <div class="tab-pane fade" id="nav-reg-uuccpp" role="tabpanel" aria-labelledby="nav-home-tab">
            <h6>Registro de Unidades con sus respectivos denominativos</h6>
            <hr>
            <div class="form-row">
                <div class="form-group col-12 col-md-4">
                    <label for="ordop_title">Denominación<span class="required-text">*</span></label>
                    <select class="form-control" name="" id="" v-model="dts_reg_uu_ccpp.categoria">
                        <option v-for="dr in denominacion" :key="dr.id" :value="dr.id" v-show="dr.state_parameter ==='A'">{{ dr.detail }}</option>
                    </select>
                </div>
                <div class="form-group col-12 col-md-4">
                    <label for="ordop_title">Nombre unidad</label>
                    <input type="text" class="form-control" id="ordop_title" placeholder="BERMEJO" v-model="dts_reg_uu_ccpp.name_port"  autocomplete="off">
                </div>
                <div class="form-group col-12 col-md-4">
                    <label for="type_ordop">Abreviatura </label>
                    <input type="text" minlength="1" maxlength="5" class="form-control" id="ordop_title" placeholder="BJ"  autocomplete="off" v-model="dts_reg_uu_ccpp.short_name_port">
                </div>
            </div>

            <div class="form-row">
                <div class="form-group col-12 col-md-4">
                    <label for="ordop_title">Distrito</label>
                    <select class="form-control" name="" id="" v-model="dts_reg_uu_ccpp.distrito">
                        <option v-for="rds in distrito" :value="rds.id" :key="rds.id">{{ rds.detail }}</option>
                    </select>
                </div>
                <div class="form-group col-12 col-md-4">
                    <label for="ordop_title">Departamento</label>
                    <select class="form-control" name="" id="" v-model="dts_reg_uu_ccpp.departamento">
                        <option v-for="dpr in departamento" :value="dpr.id" :key="dpr.id">{{ dpr.detail }}</option>
                    </select>
                </div>
                <div class="form-group col-12 col-md-2">
                    <label for="type_ordop">Latitud </label>
                    <input type="text" minlength="1" maxlength="10" class="form-control" id="ordop_title" placeholder="-1123133"  autocomplete="off" v-model="dts_reg_gg_uu.latitud">
                </div>
                <div class="form-group col-12 col-md-2">
                    <label for="type_ordop">Longitud</label>
                    <input type="text" minlength="1" maxlength="10" class="form-control" id="ordop_title" placeholder="-1.2454522"  autocomplete="off" v-model="dts_reg_gg_uu.longitud">
                </div>
            </div>

            <button class="btn btn-success col-12 col-md-4 offset-md-4" :disabled="animate_dos" @click="mSaveNewUUCCPP">
                <font-awesome-icon icon="save" :spin="animate_dos" size="2x" /> Registrar
            </button>
        </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
const qs= require('qs');
export default {
    data(){
        return{
            list_categoria_unidad:[],
            animate:false,
            animate_dos:false,
            dts_reg_gg_uu:{
                descripcion:'',
                corto:''
            },
            dts_reg_uu_ccpp:{
                categoria:0,
                departamento:0,
                name_port:'',
                short_name_port:'',
                distrito:0,
                latitud:0,
                longitud:0
            },
            list_uu_ccpp:[],
            denominacion:[],
            distrito:[],
            departamento:[]
        }
    },
    mounted(){
        this.mCallListInit();
    },
    methods:{
        async mCallListInit(){
            let denominacion_aux=await axios.get(`globals/category_captain?api_token=${Vue.auth.getToken()}`);
            let distrito_aux=await axios.get(`globals/district?api_token=${Vue.auth.getToken()}`);
            let departamento_aux=await axios.get(`globals/citys?api_token=${Vue.auth.getToken()}`);
            // console.log(denominacion_aux);
            // console.log(distrito_aux);
            // console.log(departamento_aux);
            this.denominacion=denominacion_aux.data;
            this.distrito=distrito_aux.data;
            this.departamento=departamento_aux.data;
        },
        mClearFormUU(){
            this.dts_reg_gg_uu.descripcion='';
            this.dts_reg_gg_uu.corto='';
        },
        async mSaveNewUU(){
            this.dts_reg_gg_uu.descripcion=this.dts_reg_gg_uu.descripcion.trim();
            if(this.dts_reg_gg_uu.descripcion.length===0){
                toastr.warning('Indique una descripcion para la gran Unidad', 'Advertencia');
                return false;
            }
            this.dts_reg_gg_uu.corto=this.dts_reg_gg_uu.corto.trim();
            if(this.dts_reg_gg_uu.corto.length===0){
                toastr.warning('Indique una descripcion para la gran Unidad', 'Advertencia');
                return false;
            }
            try {
                this.animate=true;
                let regNewUU=await axios.post(`regNewUU/0?api_token=${Vue.auth.getToken()}`, qs.stringify(this.dts_reg_gg_uu));
                // console.log(regNewUU);

                if(regNewUU.data.status){
                    toastr.success(regNewUU.data.response);
                    this.mClearFormUU();
                }else{
                    toastr.error(regNewUU.data.response);
                }
                setTimeout(() => {
                    this.animate=false;
                }, 2000);
            } catch (error) {
                console.log(error);
            }

        },
        async mListDenominativos(){
            let lrgd= await axios.get(`globals/category_captain?api_token=${Vue.auth.getToken()}`);
            // console.log(lrgd);
            this.list_categoria_unidad=[];
            lrgd.data.forEach((dts)=>{
                let stateAux=dts.state_parameter === 'A' ? true:false;
                let dts2={
                    id:dts.id,
                    detail:dts.detail,
                    short_detail:dts.short_detail,
                    state_parameter:dts.state_parameter,
                    state:stateAux,
                    edit:'N'
                }
                this.list_categoria_unidad.push(dts2);
            })
        },
        mChangeStateDenominativo(id){
            let updateReg;
            setTimeout(async ()=>{
                let ix=this.list_categoria_unidad.findIndex((el)=> el.id === id);
                
                if(this.list_categoria_unidad[ix].state){
                    this.list_categoria_unidad[ix].state_parameter='A';
                    updateReg=await axios.get(`updateRegister/${id}/A?api_token=${Vue.auth.getToken()}`);
                }else{
                    this.list_categoria_unidad[ix].state_parameter='I';
                    updateReg=await axios.get(`updateRegister/${id}/I?api_token=${Vue.auth.getToken()}`);
                }
            }, 300)
            // console.log(updateReg)
        },
        async mListUUCCPP(){
            let lrug= await axios.get(`getDtsCaptainListComplete?api_token=${Vue.auth.getToken()}`);
            // console.log(lrug);
            this.list_uu_ccpp=[];
            lrug.data.forEach((dts)=>{
                let stateAux=dts.status === 'A' ? true:false;
                let dts2={
                    id:dts.id,
                    name_port:dts.name_port,
                    short_category:dts.short_category,
                    status:stateAux,
                    state_parameter:dts.status,
                }
                this.list_uu_ccpp.push(dts2);
            })
        },
        mChangeStateUUCCPP(id){
            let updateReg;
            setTimeout(async ()=>{
                let ix=this.list_uu_ccpp.findIndex((el)=> el.id === id);
                
                if(this.list_uu_ccpp[ix].status){
                    this.list_uu_ccpp[ix].state_parameter='A';
                    updateReg=await axios.get(`updateRegisterUUCCPP/${id}/A?api_token=${Vue.auth.getToken()}`);
                }else{
                    this.list_uu_ccpp[ix].state_parameter='I';
                    updateReg=await axios.get(`updateRegisterUUCCPP/${id}/I?api_token=${Vue.auth.getToken()}`);
                }
            }, 300)
            // console.log(updateReg)
        },
        mValidateFormUUCCPP(){
            if(this.dts_reg_uu_ccpp.categoria===0){
                toastr.warning('Seleccione una categoria', 'Advertencia');
                return false;
            }
            if(this.dts_reg_uu_ccpp.departamento===0){
                toastr.warning('Seleccione un Departamento', 'Advertencia');
                return false;
            }
            if(this.dts_reg_uu_ccpp.distrito===0){
                toastr.warning('Seleccione un Distrito', 'Advertencia');
                return false;
            }
            this.dts_reg_uu_ccpp.name_port=this.dts_reg_uu_ccpp.name_port.trim();
            if(this.dts_reg_uu_ccpp.name_port.length===0){
                toastr.warning('Indique una descripcion para de la Unidad', 'Advertencia');
                return false;
            }
            this.dts_reg_uu_ccpp.short_name_port=this.dts_reg_uu_ccpp.short_name_port.trim();
            console.log(this.dts_reg_uu_ccpp.short_name_port);
            if(this.dts_reg_uu_ccpp.short_name_port.length===0){
                toastr.warning('Indique una descripcion para Abreviatura', 'Advertencia');
                return false;
            }
            return true;
        },
        mClearFormUUCCPP(){            
            this.dts_reg_uu_ccpp.categoria=0;
            this.dts_reg_uu_ccpp.departamento=0;
            this.dts_reg_uu_ccpp.name_port='';
            this.dts_reg_uu_ccpp.short_name_port='';
            this.dts_reg_uu_ccpp.distrito=0;
            this.dts_reg_uu_ccpp.latitud=0;
            this.dts_reg_uu_ccpp.longitud=0;
        },
        async mSaveNewUUCCPP(){
            try {
                if(this.mValidateFormUUCCPP()){
                    this.animate_dos=true;
                    let regNewUU=await axios.post(`regNewUU/1?api_token=${Vue.auth.getToken()}`, qs.stringify(this.dts_reg_uu_ccpp));
                    // console.log(regNewUU);
                    if(regNewUU.data.status){

                        toastr.success(regNewUU.data.response);
                        setTimeout(()=>{
                            this.animate_dos=false;
                            this.mClearFormUUCCPP();
                        },2000)
                    }else{
                        toastr.error(regNewUU.data.response);
                    }
                }                                
            } catch (error) {
                console.log(error);
            }
        }
    },
    computed:{

    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/captain/AddUnitCaptain.vue